module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"urlWorking":"This provider is on","urlNotWorking":"This provider is off"},"fr":{"urlWorking":"This provider is on","urlNotWorking":"This provider is off"}}')
  delete Component.options._Ctor
}
